import React, { useEffect, useState } from "react";

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from "sweetalert2";

import 'common/css/master.css';

import QrLinkPdf from "../pdf/qrLinkPdf";
import { getStudentListSvc } from "./hpcParentAssessmentSvc";



const ParentAssessmentSlider = ({ clsId, sectionId, clsSection, closeSlider }) => {

    const [loaderSlider, setLoaderSlider] = useState("none");
    const [lstStudent, setLstStudent] = useState([]);

    useEffect(() => {
        // console.log("ParentAssessmentSlider called");
        // console.log("clsId", clsId);
        // console.log("sectionId", sectionId);
        getStudentList(clsId, sectionId);
    }, [clsId, sectionId]);

    const getStudentList = (pClsId, pSectionId) => {
        // console.log("getStudentList called");
        setLoaderSlider("block");
        getStudentListSvc(pClsId, pSectionId, getStudentListResponse);
    }

    const getStudentListResponse = async (data) => {
        // console.log("getStudentListResponse called, data", data);
        if (data.status === "Success") {
            setLstStudent(data.lstClassStudents);
            if (!data.lstClassStudents || data.lstClassStudents.length === 0) {
                await Swal.fire({
                    title: "Alert",
                    text: `There are no students in ${clsSection}`,
                    confirmButtonText: "OK",
                });
                closeSlider();
            }

        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoaderSlider("none");
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };


    return (
        <div className="col-xs-12 col-centered padding-remove ">
            <div style={{ position: "fixed", zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '70%', top: '40%', display: loaderSlider }} >
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div >
            <ToastContainer autoClose={3000} hideProgressBar />
            <div>
                <button type="button" className='btn btn-info text-center btnCloseDiv' onClick={() => closeSlider()} style={{ right: "60%" }}>
                    <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
                </button>
                <div className='col-sm-12 padding-remove' style={{ margin: 0 }}>
                    {
                        lstStudent ?
                            <QrLinkPdf
                                lstStudent={lstStudent}
                                clsSection={clsSection}
                                clsId={clsId}
                            />
                            : null
                    }
                </div>
            </div>
        </div>
    );
}
export default ParentAssessmentSlider;
